import Highcharts from 'highcharts';

import HighchartsStock from 'highcharts/modules/stock';
import HighchartsMap from 'highcharts/modules/map';
import HighchartsHeatmap from 'highcharts/modules/heatmap';
import HighchartsNoData from 'highcharts/modules/no-data-to-display';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsIndicators from 'highcharts/indicators/indicators';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import HighchartsData from 'highcharts/modules/data';
import HighchartsFunnel from 'highcharts/modules/funnel';
import HighchartsAnnotations from 'highcharts/modules/annotations';
import HighchartsAnnotationsAdvanced from 'highcharts/modules/annotations-advanced';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsItemSeries from 'highcharts/modules/item-series';
import HighchartsPatternFill from 'highcharts/modules/pattern-fill';
import HighchartsTilemap from 'highcharts/modules/tilemap';

let initialized = false

function initHighcharts() {
  if (initialized) return
  initialized = true


if (typeof HighchartsPatternFill === 'function') {
	// @ts-ignore
	HighchartsPatternFill(Highcharts);
}

if (typeof HighchartsStock === 'function') {
	// @ts-ignore
	HighchartsStock(Highcharts);
}

if (typeof HighchartsMap === 'function') {
	// @ts-ignore
	HighchartsMap(Highcharts);
}

if (typeof HighchartsHeatmap === 'function') {
	// @ts-ignore
	HighchartsHeatmap(Highcharts);
}

if (typeof HighchartsTilemap === 'function') {
	// @ts-ignore
	HighchartsTilemap(Highcharts);
}

if (typeof HighchartsNoData === 'function') {
	// @ts-ignore
	HighchartsNoData(Highcharts);
}

if (typeof HighchartsMore === 'function') {
	// @ts-ignore
	HighchartsMore(Highcharts);
}

if (typeof HighchartsIndicators === 'function') {
	// @ts-ignore
	HighchartsIndicators(Highcharts);
}

if (typeof HighchartsExporting === 'function') {
	// @ts-ignore
	HighchartsExporting(Highcharts);
}

if (typeof HighchartsExportData === 'function') {
	// @ts-ignore
	HighchartsExportData(Highcharts);
}


if (typeof HighchartsAccessibility === 'function') {
	// @ts-ignore
	HighchartsAccessibility(Highcharts);
}

if (typeof HighchartsData === 'function') {
	// @ts-ignore
	HighchartsData(Highcharts);
}

if (typeof HighchartsFunnel === 'function') {
	// @ts-ignore
	HighchartsFunnel(Highcharts);
}

if (typeof HighchartsAnnotations === 'function') {
	// @ts-ignore
	HighchartsAnnotations(Highcharts);
}

if (typeof HighchartsAnnotationsAdvanced === 'function') {
	// @ts-ignore
	HighchartsAnnotationsAdvanced(Highcharts);
}

if (typeof HighchartsSolidGauge === 'function') {
	// @ts-ignore
	HighchartsSolidGauge(Highcharts);
}

if (typeof HighchartsItemSeries === 'function') {
	// @ts-ignore
	HighchartsItemSeries(Highcharts);
}

// Optional: expose for debugging
// if (typeof window !== 'undefined') {
//   (window as any).Highcharts = Highcharts
// }
}

initHighcharts();

export default Highcharts;
